import { compose, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import { actions as notifyActions } from 'redux-notifications';

const withNotifications = (actions: { [key: string]: ({}: object) => any }) =>
  compose(
    connect(),
    withHandlers({
      addError:
        ({ dispatch }) =>
        (message = 'Akce se neprovedla') => {
          dispatch(
            notifyActions.notifSend({
              message,
              kind: 'danger',
              dismissAfter: 6000
            })
          );
        },
      addSuccess:
        ({ dispatch }) =>
        (message = 'Akce byla úspěšne provedena') => {
          dispatch(
            notifyActions.notifSend({
              message,
              kind: 'success',
              dismissAfter: 6000
            })
          );
        }
    }),
    withProps(({ addError, addSuccess }) => {
      let result = {};
      for (const actionName of Object.keys(actions)) {
        result = { [`${actionName}Notify`]: actions[actionName]({ addError, addSuccess }), ...result };
      }
      return result;
    })
  );

export default withNotifications;



// WEBPACK FOOTER //
// ./src/components/hoc/withNotifications/withNotifications.ts